exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-294b7f89] .yellow {\n  background-color: #989898 !important;\n  color: #ffffff !important;\n}\n[data-v-294b7f89] .darkRed {\n  background-color: #1e49e2 !important;\n  color: #ffffff !important;\n}\n[data-v-294b7f89] .red {\n  background-color: #269924 !important;\n  color: #ffffff !important;\n}\n[data-v-294b7f89] .blue {\n  background-color: #fd349c !important;\n  color: #ffffff !important;\n}\n[data-v-294b7f89] .green {\n  /* background-color: #00c0ae !important; */\n  /* color: #ffffff !important;; */\n}", ""]);

// exports
